/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Save_To_HighlightsInputs */

const en_story_save_to_highlights = /** @type {(inputs: Story_Save_To_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save to Highlights?`)
};

const es_story_save_to_highlights = /** @type {(inputs: Story_Save_To_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Guardar en Destacados?`)
};

const fr_story_save_to_highlights = /** @type {(inputs: Story_Save_To_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer dans les temps forts ?`)
};

const de_story_save_to_highlights = /** @type {(inputs: Story_Save_To_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Highlights speichern?`)
};

const id_story_save_to_highlights = /** @type {(inputs: Story_Save_To_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan ke Sorotan?`)
};

/** @type {(inputs: Story_Save_To_HighlightsInputs) => LocalizedString} */
const ja_story_save_to_highlights = en_story_save_to_highlights;

/** @type {(inputs: Story_Save_To_HighlightsInputs) => LocalizedString} */
const zh_story_save_to_highlights = en_story_save_to_highlights;

/** @type {(inputs: Story_Save_To_HighlightsInputs) => LocalizedString} */
const ar_story_save_to_highlights = en_story_save_to_highlights;

/** @type {(inputs: Story_Save_To_HighlightsInputs) => LocalizedString} */
const it_story_save_to_highlights = en_story_save_to_highlights;

/** @type {(inputs: Story_Save_To_HighlightsInputs) => LocalizedString} */
const ru_story_save_to_highlights = en_story_save_to_highlights;

/** @type {(inputs: Story_Save_To_HighlightsInputs) => LocalizedString} */
const pt_story_save_to_highlights = en_story_save_to_highlights;

/** @type {(inputs: Story_Save_To_HighlightsInputs) => LocalizedString} */
const ko_story_save_to_highlights = en_story_save_to_highlights;

/**
* | output |
* | --- |
* | "Save to Highlights?" |
*
* @param {Story_Save_To_HighlightsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_save_to_highlights = /** @type {((inputs?: Story_Save_To_HighlightsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Save_To_HighlightsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_save_to_highlights(inputs)
	if (locale === "es") return es_story_save_to_highlights(inputs)
	if (locale === "fr") return fr_story_save_to_highlights(inputs)
	if (locale === "de") return de_story_save_to_highlights(inputs)
	if (locale === "ja") return ja_story_save_to_highlights(inputs)
	if (locale === "zh") return zh_story_save_to_highlights(inputs)
	if (locale === "ar") return ar_story_save_to_highlights(inputs)
	if (locale === "id") return id_story_save_to_highlights(inputs)
	if (locale === "it") return it_story_save_to_highlights(inputs)
	if (locale === "ru") return ru_story_save_to_highlights(inputs)
	if (locale === "pt") return pt_story_save_to_highlights(inputs)
	return ko_story_save_to_highlights(inputs)
});